import { render, staticRenderFns } from "./folder-form.vue?vue&type=template&id=fc53796a&scoped=true"
import script from "./folder-form.vue?vue&type=script&lang=js"
export * from "./folder-form.vue?vue&type=script&lang=js"
import style0 from "./folder-form.vue?vue&type=style&index=0&id=fc53796a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc53796a",
  null
  
)

export default component.exports